import CharField from '@/components/fields/forms/CharField'
import ChoiceField from '@/components/fields/forms/ChoiceField'
import TextField from '@/components/fields/forms/TextField'
import FileField from '@/components/fields/forms/FileField'


export default {
    CharField,
    ChoiceField,
    TextField,
    FileField,
}



// WEBPACK FOOTER //
// ./src/components/fields/availableFieldsForms.js